import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/circle-plus/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/circle-plus/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/circle-plus/locales/fi/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages);


export class IconCirclePlus24 extends LitElement {
  render() {
      const title = i18n.t({ message: `Circle with plus sign`, id: 'icon.title.circle-plus', comment: 'Title for circle-plus icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="24"height="24"fill="none"viewBox="0 0 24 24" part="w-icon-circle-plus-24-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 7.5v9M7.5 12h9M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25"></path></svg>`; }
}
if (!customElements.get('w-icon-circle-plus-24')) {
  customElements.define('w-icon-circle-plus-24', IconCirclePlus24);
}